import { useLanguage } from '../../hooks/useLanguage';
import { useLenis } from '../../hooks/useLenis';
import { MagneticButton } from '../UI/MagneticButton';

export const Hero = () => {
  const { t } = useLanguage();
  const { scrollTo } = useLenis();

  return (
    <section
      id="room-hero"
      className="relative flex items-center justify-center min-h-screen px-6 pt-20"
      role="region"
      aria-label="Entrance"
    >
      {/* Background */}
      <div 
        className="absolute inset-0 z-0 opacity-30"
        style={{
          backgroundImage: 'url(/images/hero-poster.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(2px)',
        }}
      />
      
      <div className="container relative z-10 mx-auto text-center" data-depth="0.12">
        <div className="flex flex-col items-center gap-6 mb-8">
          <img
            src="/images/gaiamundi-logo.png"
            alt="Gaiamundi Logo"
            width={64}
            height={64}
            className="object-contain w-16 h-16 animate-float"
            loading="eager"
          />
          
          <h1
            className="
              font-syne font-extrabold tracking-tight
              text-[clamp(2rem,5vw,5rem)]
              leading-[0.9]
              break-words
              hyphens-auto
            "
          >
            {t('brandTitle')}
          </h1>
        </div>
        
        <p className="text-lg md:text-xl text-[var(--muted)] max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('hero')}
        </p>
        
        <div className="flex flex-wrap justify-center gap-4">
          <MagneticButton
            onClick={() => scrollTo('#gallery')}
            className="px-8 py-4 bg-[var(--accent)] text-[var(--bg)] font-semibold rounded-full hover:brightness-110 transition-all"
          >
            {t('enterGallery')}
          </MagneticButton>
          
          <MagneticButton
            onClick={() => scrollTo('#manifest')}
            className="px-8 py-4 border-2 border-[var(--accent)] text-[var(--accent)] font-semibold rounded-full hover:bg-[var(--accent)] hover:text-[var(--bg)] transition-all"
          >
            {t('manifestLink')}
          </MagneticButton>
        </div>
      </div>
    </section>
  );
};